"use strict";

/* tslint:disable */
/* eslint-disable */
/**
 * OpenAI API
 * APIs for sampling from and fine-tuning language models
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var _classCallCheck = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenAIApi = exports.OpenAIApiFactory = exports.OpenAIApiFp = exports.OpenAIApiAxiosParamCreator = exports.CreateImageRequestResponseFormatEnum = exports.CreateImageRequestSizeEnum = exports.ChatCompletionResponseMessageRoleEnum = exports.ChatCompletionRequestMessageRoleEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.ChatCompletionRequestMessageRoleEnum = {
  System: 'system',
  User: 'user',
  Assistant: 'assistant'
};
exports.ChatCompletionResponseMessageRoleEnum = {
  System: 'system',
  User: 'user',
  Assistant: 'assistant'
};
exports.CreateImageRequestSizeEnum = {
  _256x256: '256x256',
  _512x512: '512x512',
  _1024x1024: '1024x1024'
};
exports.CreateImageRequestResponseFormatEnum = {
  Url: 'url',
  B64Json: 'b64_json'
};
/**
 * OpenAIApi - axios parameter creator
 * @export
 */
exports.OpenAIApiAxiosParamCreator = function (configuration) {
  var _this = this;
  return {
    /**
     *
     * @summary Immediately cancel a fine-tune job.
     * @param {string} fineTuneId The ID of the fine-tune job to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelFineTune: function cancelFineTune(fineTuneId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // verify required parameter 'fineTuneId' is not null or undefined
              common_1.assertParamExists('cancelFineTune', 'fineTuneId', fineTuneId);
              localVarPath = "/fine-tunes/{fine_tune_id}/cancel".replace("{".concat("fine_tune_id", "}"), encodeURIComponent(String(fineTuneId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    },
    /**
     *
     * @summary Answers the specified question using the provided documents and examples.  The endpoint first [searches](/docs/api-reference/searches) over provided documents or files to find relevant context. The relevant context is combined with the provided examples and question to create the prompt for [completion](/docs/api-reference/completions).
     * @param {CreateAnswerRequest} createAnswerRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createAnswer: function createAnswer(createAnswerRequest) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // verify required parameter 'createAnswerRequest' is not null or undefined
              common_1.assertParamExists('createAnswer', 'createAnswerRequest', createAnswerRequest);
              localVarPath = "/answers"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAnswerRequest, localVarRequestOptions, configuration);
              return _context2.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    },
    /**
     *
     * @summary Creates a completion for the chat message
     * @param {CreateChatCompletionRequest} createChatCompletionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createChatCompletion: function createChatCompletion(createChatCompletionRequest) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // verify required parameter 'createChatCompletionRequest' is not null or undefined
              common_1.assertParamExists('createChatCompletion', 'createChatCompletionRequest', createChatCompletionRequest);
              localVarPath = "/chat/completions"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createChatCompletionRequest, localVarRequestOptions, configuration);
              return _context3.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
    },
    /**
     *
     * @summary Classifies the specified `query` using provided examples.  The endpoint first [searches](/docs/api-reference/searches) over the labeled examples to select the ones most relevant for the particular query. Then, the relevant examples are combined with the query to construct a prompt to produce the final label via the [completions](/docs/api-reference/completions) endpoint.  Labeled examples can be provided via an uploaded `file`, or explicitly listed in the request using the `examples` parameter for quick tests and small scale use cases.
     * @param {CreateClassificationRequest} createClassificationRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createClassification: function createClassification(createClassificationRequest) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // verify required parameter 'createClassificationRequest' is not null or undefined
              common_1.assertParamExists('createClassification', 'createClassificationRequest', createClassificationRequest);
              localVarPath = "/classifications"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createClassificationRequest, localVarRequestOptions, configuration);
              return _context4.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
    },
    /**
     *
     * @summary Creates a completion for the provided prompt and parameters
     * @param {CreateCompletionRequest} createCompletionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompletion: function createCompletion(createCompletionRequest) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // verify required parameter 'createCompletionRequest' is not null or undefined
              common_1.assertParamExists('createCompletion', 'createCompletionRequest', createCompletionRequest);
              localVarPath = "/completions"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createCompletionRequest, localVarRequestOptions, configuration);
              return _context5.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
    },
    /**
     *
     * @summary Creates a new edit for the provided input, instruction, and parameters.
     * @param {CreateEditRequest} createEditRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEdit: function createEdit(createEditRequest) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              // verify required parameter 'createEditRequest' is not null or undefined
              common_1.assertParamExists('createEdit', 'createEditRequest', createEditRequest);
              localVarPath = "/edits"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createEditRequest, localVarRequestOptions, configuration);
              return _context6.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
    },
    /**
     *
     * @summary Creates an embedding vector representing the input text.
     * @param {CreateEmbeddingRequest} createEmbeddingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmbedding: function createEmbedding(createEmbeddingRequest) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              // verify required parameter 'createEmbeddingRequest' is not null or undefined
              common_1.assertParamExists('createEmbedding', 'createEmbeddingRequest', createEmbeddingRequest);
              localVarPath = "/embeddings"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createEmbeddingRequest, localVarRequestOptions, configuration);
              return _context7.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
    },
    /**
     *
     * @summary Upload a file that contains document(s) to be used across various endpoints/features. Currently, the size of all the files uploaded by one organization can be up to 1 GB. Please contact us if you need to increase the storage limit.
     * @param {File} file Name of the [JSON Lines](https://jsonlines.readthedocs.io/en/latest/) file to be uploaded.  If the &#x60;purpose&#x60; is set to \\\&quot;fine-tune\\\&quot;, each line is a JSON record with \\\&quot;prompt\\\&quot; and \\\&quot;completion\\\&quot; fields representing your [training examples](/docs/guides/fine-tuning/prepare-training-data).
     * @param {string} purpose The intended purpose of the uploaded documents.  Use \\\&quot;fine-tune\\\&quot; for [Fine-tuning](/docs/api-reference/fine-tunes). This allows us to validate the format of the uploaded file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFile: function createFile(file, purpose) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              // verify required parameter 'file' is not null or undefined
              common_1.assertParamExists('createFile', 'file', file);
              // verify required parameter 'purpose' is not null or undefined
              common_1.assertParamExists('createFile', 'purpose', purpose);
              localVarPath = "/files"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
              if (file !== undefined) {
                localVarFormParams.append('file', file);
              }
              if (purpose !== undefined) {
                localVarFormParams.append('purpose', purpose);
              }
              localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), localVarFormParams.getHeaders()), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = localVarFormParams;
              return _context8.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 17:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
    },
    /**
     *
     * @summary Creates a job that fine-tunes a specified model from a given dataset.  Response includes details of the enqueued job including job status and the name of the fine-tuned models once complete.  [Learn more about Fine-tuning](/docs/guides/fine-tuning)
     * @param {CreateFineTuneRequest} createFineTuneRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFineTune: function createFineTune(createFineTuneRequest) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              // verify required parameter 'createFineTuneRequest' is not null or undefined
              common_1.assertParamExists('createFineTune', 'createFineTuneRequest', createFineTuneRequest);
              localVarPath = "/fine-tunes"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFineTuneRequest, localVarRequestOptions, configuration);
              return _context9.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
    },
    /**
     *
     * @summary Creates an image given a prompt.
     * @param {CreateImageRequest} createImageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createImage: function createImage(createImageRequest) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              // verify required parameter 'createImageRequest' is not null or undefined
              common_1.assertParamExists('createImage', 'createImageRequest', createImageRequest);
              localVarPath = "/images/generations"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createImageRequest, localVarRequestOptions, configuration);
              return _context10.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
    },
    /**
     *
     * @summary Creates an edited or extended image given an original image and a prompt.
     * @param {File} image The image to edit. Must be a valid PNG file, less than 4MB, and square. If mask is not provided, image must have transparency, which will be used as the mask.
     * @param {string} prompt A text description of the desired image(s). The maximum length is 1000 characters.
     * @param {File} [mask] An additional image whose fully transparent areas (e.g. where alpha is zero) indicate where &#x60;image&#x60; should be edited. Must be a valid PNG file, less than 4MB, and have the same dimensions as &#x60;image&#x60;.
     * @param {number} [n] The number of images to generate. Must be between 1 and 10.
     * @param {string} [size] The size of the generated images. Must be one of &#x60;256x256&#x60;, &#x60;512x512&#x60;, or &#x60;1024x1024&#x60;.
     * @param {string} [responseFormat] The format in which the generated images are returned. Must be one of &#x60;url&#x60; or &#x60;b64_json&#x60;.
     * @param {string} [user] A unique identifier representing your end-user, which can help OpenAI to monitor and detect abuse. [Learn more](/docs/guides/safety-best-practices/end-user-ids).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createImageEdit: function createImageEdit(image, prompt, mask, n, size, responseFormat, user) {
      var options = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              // verify required parameter 'image' is not null or undefined
              common_1.assertParamExists('createImageEdit', 'image', image);
              // verify required parameter 'prompt' is not null or undefined
              common_1.assertParamExists('createImageEdit', 'prompt', prompt);
              localVarPath = "/images/edits"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
              if (image !== undefined) {
                localVarFormParams.append('image', image);
              }
              if (mask !== undefined) {
                localVarFormParams.append('mask', mask);
              }
              if (prompt !== undefined) {
                localVarFormParams.append('prompt', prompt);
              }
              if (n !== undefined) {
                localVarFormParams.append('n', n);
              }
              if (size !== undefined) {
                localVarFormParams.append('size', size);
              }
              if (responseFormat !== undefined) {
                localVarFormParams.append('response_format', responseFormat);
              }
              if (user !== undefined) {
                localVarFormParams.append('user', user);
              }
              localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), localVarFormParams.getHeaders()), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = localVarFormParams;
              return _context11.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 22:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
    },
    /**
     *
     * @summary Creates a variation of a given image.
     * @param {File} image The image to use as the basis for the variation(s). Must be a valid PNG file, less than 4MB, and square.
     * @param {number} [n] The number of images to generate. Must be between 1 and 10.
     * @param {string} [size] The size of the generated images. Must be one of &#x60;256x256&#x60;, &#x60;512x512&#x60;, or &#x60;1024x1024&#x60;.
     * @param {string} [responseFormat] The format in which the generated images are returned. Must be one of &#x60;url&#x60; or &#x60;b64_json&#x60;.
     * @param {string} [user] A unique identifier representing your end-user, which can help OpenAI to monitor and detect abuse. [Learn more](/docs/guides/safety-best-practices/end-user-ids).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createImageVariation: function createImageVariation(image, n, size, responseFormat, user) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              // verify required parameter 'image' is not null or undefined
              common_1.assertParamExists('createImageVariation', 'image', image);
              localVarPath = "/images/variations"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
              if (image !== undefined) {
                localVarFormParams.append('image', image);
              }
              if (n !== undefined) {
                localVarFormParams.append('n', n);
              }
              if (size !== undefined) {
                localVarFormParams.append('size', size);
              }
              if (responseFormat !== undefined) {
                localVarFormParams.append('response_format', responseFormat);
              }
              if (user !== undefined) {
                localVarFormParams.append('user', user);
              }
              localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), localVarFormParams.getHeaders()), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = localVarFormParams;
              return _context12.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 19:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
    },
    /**
     *
     * @summary Classifies if text violates OpenAI\'s Content Policy
     * @param {CreateModerationRequest} createModerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createModeration: function createModeration(createModerationRequest) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              // verify required parameter 'createModerationRequest' is not null or undefined
              common_1.assertParamExists('createModeration', 'createModerationRequest', createModerationRequest);
              localVarPath = "/moderations"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createModerationRequest, localVarRequestOptions, configuration);
              return _context13.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 13:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
    },
    /**
     *
     * @summary The search endpoint computes similarity scores between provided query and documents. Documents can be passed directly to the API if there are no more than 200 of them.  To go beyond the 200 document limit, documents can be processed offline and then used for efficient retrieval at query time. When `file` is set, the search endpoint searches over all the documents in the given file and returns up to the `max_rerank` number of documents. These documents will be returned along with their search scores.  The similarity score is a positive score that usually ranges from 0 to 300 (but can sometimes go higher), where a score above 200 usually means the document is semantically similar to the query.
     * @param {string} engineId The ID of the engine to use for this request.  You can select one of &#x60;ada&#x60;, &#x60;babbage&#x60;, &#x60;curie&#x60;, or &#x60;davinci&#x60;.
     * @param {CreateSearchRequest} createSearchRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createSearch: function createSearch(engineId, createSearchRequest) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              // verify required parameter 'engineId' is not null or undefined
              common_1.assertParamExists('createSearch', 'engineId', engineId);
              // verify required parameter 'createSearchRequest' is not null or undefined
              common_1.assertParamExists('createSearch', 'createSearchRequest', createSearchRequest);
              localVarPath = "/engines/{engine_id}/search".replace("{".concat("engine_id", "}"), encodeURIComponent(String(engineId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarHeaderParameter['Content-Type'] = 'application/json';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSearchRequest, localVarRequestOptions, configuration);
              return _context14.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 14:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
    },
    /**
     *
     * @summary Transcribes audio into the input language.
     * @param {File} file The audio file to transcribe, in one of these formats: mp3, mp4, mpeg, mpga, m4a, wav, or webm.
     * @param {string} model ID of the model to use. Only &#x60;whisper-1&#x60; is currently available.
     * @param {string} [prompt] An optional text to guide the model\\\&#39;s style or continue a previous audio segment. The [prompt](/docs/guides/speech-to-text/prompting) should match the audio language.
     * @param {string} [responseFormat] The format of the transcript output, in one of these options: json, text, srt, verbose_json, or vtt.
     * @param {number} [temperature] The sampling temperature, between 0 and 1. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic. If set to 0, the model will use [log probability](https://en.wikipedia.org/wiki/Log_probability) to automatically increase the temperature until certain thresholds are hit.
     * @param {string} [language] The language of the input audio. Supplying the input language in [ISO-639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format will improve accuracy and latency.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTranscription: function createTranscription(file, model, prompt, responseFormat, temperature, language) {
      var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              // verify required parameter 'file' is not null or undefined
              common_1.assertParamExists('createTranscription', 'file', file);
              // verify required parameter 'model' is not null or undefined
              common_1.assertParamExists('createTranscription', 'model', model);
              localVarPath = "/audio/transcriptions"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
              if (file !== undefined) {
                localVarFormParams.append('file', file);
              }
              if (model !== undefined) {
                localVarFormParams.append('model', model);
              }
              if (prompt !== undefined) {
                localVarFormParams.append('prompt', prompt);
              }
              if (responseFormat !== undefined) {
                localVarFormParams.append('response_format', responseFormat);
              }
              if (temperature !== undefined) {
                localVarFormParams.append('temperature', temperature);
              }
              if (language !== undefined) {
                localVarFormParams.append('language', language);
              }
              localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), localVarFormParams.getHeaders()), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = localVarFormParams;
              return _context15.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 21:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
    },
    /**
     *
     * @summary Translates audio into into English.
     * @param {File} file The audio file to translate, in one of these formats: mp3, mp4, mpeg, mpga, m4a, wav, or webm.
     * @param {string} model ID of the model to use. Only &#x60;whisper-1&#x60; is currently available.
     * @param {string} [prompt] An optional text to guide the model\\\&#39;s style or continue a previous audio segment. The [prompt](/docs/guides/speech-to-text/prompting) should be in English.
     * @param {string} [responseFormat] The format of the transcript output, in one of these options: json, text, srt, verbose_json, or vtt.
     * @param {number} [temperature] The sampling temperature, between 0 and 1. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic. If set to 0, the model will use [log probability](https://en.wikipedia.org/wiki/Log_probability) to automatically increase the temperature until certain thresholds are hit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTranslation: function createTranslation(file, model, prompt, responseFormat, temperature) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              // verify required parameter 'file' is not null or undefined
              common_1.assertParamExists('createTranslation', 'file', file);
              // verify required parameter 'model' is not null or undefined
              common_1.assertParamExists('createTranslation', 'model', model);
              localVarPath = "/audio/translations"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'POST'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
              if (file !== undefined) {
                localVarFormParams.append('file', file);
              }
              if (model !== undefined) {
                localVarFormParams.append('model', model);
              }
              if (prompt !== undefined) {
                localVarFormParams.append('prompt', prompt);
              }
              if (responseFormat !== undefined) {
                localVarFormParams.append('response_format', responseFormat);
              }
              if (temperature !== undefined) {
                localVarFormParams.append('temperature', temperature);
              }
              localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), localVarFormParams.getHeaders()), headersFromBaseOptions), options.headers);
              localVarRequestOptions.data = localVarFormParams;
              return _context16.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 20:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
    },
    /**
     *
     * @summary Delete a file.
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile: function deleteFile(fileId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              // verify required parameter 'fileId' is not null or undefined
              common_1.assertParamExists('deleteFile', 'fileId', fileId);
              localVarPath = "/files/{file_id}".replace("{".concat("file_id", "}"), encodeURIComponent(String(fileId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'DELETE'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context17.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 11:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
    },
    /**
     *
     * @summary Delete a fine-tuned model. You must have the Owner role in your organization.
     * @param {string} model The model to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteModel: function deleteModel(model) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              // verify required parameter 'model' is not null or undefined
              common_1.assertParamExists('deleteModel', 'model', model);
              localVarPath = "/models/{model}".replace("{".concat("model", "}"), encodeURIComponent(String(model))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'DELETE'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context18.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 11:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
    },
    /**
     *
     * @summary Returns the contents of the specified file
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadFile: function downloadFile(fileId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              // verify required parameter 'fileId' is not null or undefined
              common_1.assertParamExists('downloadFile', 'fileId', fileId);
              localVarPath = "/files/{file_id}/content".replace("{".concat("file_id", "}"), encodeURIComponent(String(fileId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context19.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 11:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
    },
    /**
     *
     * @summary Lists the currently available (non-finetuned) models, and provides basic information about each one such as the owner and availability.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    listEngines: function listEngines() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              localVarPath = "/engines"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context20.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 10:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
    },
    /**
     *
     * @summary Returns a list of files that belong to the user\'s organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listFiles: function listFiles() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              localVarPath = "/files"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context21.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 10:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
    },
    /**
     *
     * @summary Get fine-grained status updates for a fine-tune job.
     * @param {string} fineTuneId The ID of the fine-tune job to get events for.
     * @param {boolean} [stream] Whether to stream events for the fine-tune job. If set to true, events will be sent as data-only [server-sent events](https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events/Using_server-sent_events#Event_stream_format) as they become available. The stream will terminate with a &#x60;data: [DONE]&#x60; message when the job is finished (succeeded, cancelled, or failed).  If set to false, only events generated so far will be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listFineTuneEvents: function listFineTuneEvents(fineTuneId, stream) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              // verify required parameter 'fineTuneId' is not null or undefined
              common_1.assertParamExists('listFineTuneEvents', 'fineTuneId', fineTuneId);
              localVarPath = "/fine-tunes/{fine_tune_id}/events".replace("{".concat("fine_tune_id", "}"), encodeURIComponent(String(fineTuneId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              if (stream !== undefined) {
                localVarQueryParameter['stream'] = stream;
              }
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context22.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 12:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
    },
    /**
     *
     * @summary List your organization\'s fine-tuning jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listFineTunes: function listFineTunes() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              localVarPath = "/fine-tunes"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context23.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 10:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }));
    },
    /**
     *
     * @summary Lists the currently available models, and provides basic information about each one such as the owner and availability.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listModels: function listModels() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              localVarPath = "/models"; // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context24.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 10:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }));
    },
    /**
     *
     * @summary Retrieves a model instance, providing basic information about it such as the owner and availability.
     * @param {string} engineId The ID of the engine to use for this request
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    retrieveEngine: function retrieveEngine(engineId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              // verify required parameter 'engineId' is not null or undefined
              common_1.assertParamExists('retrieveEngine', 'engineId', engineId);
              localVarPath = "/engines/{engine_id}".replace("{".concat("engine_id", "}"), encodeURIComponent(String(engineId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context25.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 11:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }));
    },
    /**
     *
     * @summary Returns information about a specific file.
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveFile: function retrieveFile(fileId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              // verify required parameter 'fileId' is not null or undefined
              common_1.assertParamExists('retrieveFile', 'fileId', fileId);
              localVarPath = "/files/{file_id}".replace("{".concat("file_id", "}"), encodeURIComponent(String(fileId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context26.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 11:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }));
    },
    /**
     *
     * @summary Gets info about the fine-tune job.  [Learn more about Fine-tuning](/docs/guides/fine-tuning)
     * @param {string} fineTuneId The ID of the fine-tune job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveFineTune: function retrieveFineTune(fineTuneId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              // verify required parameter 'fineTuneId' is not null or undefined
              common_1.assertParamExists('retrieveFineTune', 'fineTuneId', fineTuneId);
              localVarPath = "/fine-tunes/{fine_tune_id}".replace("{".concat("fine_tune_id", "}"), encodeURIComponent(String(fineTuneId))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context27.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 11:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }));
    },
    /**
     *
     * @summary Retrieves a model instance, providing basic information about the model such as the owner and permissioning.
     * @param {string} model The ID of the model to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveModel: function retrieveModel(model) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              // verify required parameter 'model' is not null or undefined
              common_1.assertParamExists('retrieveModel', 'model', model);
              localVarPath = "/models/{model}".replace("{".concat("model", "}"), encodeURIComponent(String(model))); // use dummy base URL string because the URL constructor only accepts absolute URLs.
              localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
              if (configuration) {
                baseOptions = configuration.baseOptions;
              }
              localVarRequestOptions = Object.assign(Object.assign({
                method: 'GET'
              }, baseOptions), options);
              localVarHeaderParameter = {};
              localVarQueryParameter = {};
              common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
              headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
              localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
              return _context28.abrupt("return", {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions
              });
            case 11:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }));
    }
  };
};
/**
 * OpenAIApi - functional programming interface
 * @export
 */
exports.OpenAIApiFp = function (configuration) {
  var localVarAxiosParamCreator = exports.OpenAIApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Immediately cancel a fine-tune job.
     * @param {string} fineTuneId The ID of the fine-tune job to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelFineTune: function cancelFineTune(fineTuneId, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return localVarAxiosParamCreator.cancelFineTune(fineTuneId, options);
            case 2:
              localVarAxiosArgs = _context29.sent;
              return _context29.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }));
    },
    /**
     *
     * @summary Answers the specified question using the provided documents and examples.  The endpoint first [searches](/docs/api-reference/searches) over provided documents or files to find relevant context. The relevant context is combined with the provided examples and question to create the prompt for [completion](/docs/api-reference/completions).
     * @param {CreateAnswerRequest} createAnswerRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createAnswer: function createAnswer(createAnswerRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return localVarAxiosParamCreator.createAnswer(createAnswerRequest, options);
            case 2:
              localVarAxiosArgs = _context30.sent;
              return _context30.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }));
    },
    /**
     *
     * @summary Creates a completion for the chat message
     * @param {CreateChatCompletionRequest} createChatCompletionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createChatCompletion: function createChatCompletion(createChatCompletionRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return localVarAxiosParamCreator.createChatCompletion(createChatCompletionRequest, options);
            case 2:
              localVarAxiosArgs = _context31.sent;
              return _context31.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      }));
    },
    /**
     *
     * @summary Classifies the specified `query` using provided examples.  The endpoint first [searches](/docs/api-reference/searches) over the labeled examples to select the ones most relevant for the particular query. Then, the relevant examples are combined with the query to construct a prompt to produce the final label via the [completions](/docs/api-reference/completions) endpoint.  Labeled examples can be provided via an uploaded `file`, or explicitly listed in the request using the `examples` parameter for quick tests and small scale use cases.
     * @param {CreateClassificationRequest} createClassificationRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createClassification: function createClassification(createClassificationRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return localVarAxiosParamCreator.createClassification(createClassificationRequest, options);
            case 2:
              localVarAxiosArgs = _context32.sent;
              return _context32.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }));
    },
    /**
     *
     * @summary Creates a completion for the provided prompt and parameters
     * @param {CreateCompletionRequest} createCompletionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompletion: function createCompletion(createCompletionRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return localVarAxiosParamCreator.createCompletion(createCompletionRequest, options);
            case 2:
              localVarAxiosArgs = _context33.sent;
              return _context33.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }));
    },
    /**
     *
     * @summary Creates a new edit for the provided input, instruction, and parameters.
     * @param {CreateEditRequest} createEditRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEdit: function createEdit(createEditRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return localVarAxiosParamCreator.createEdit(createEditRequest, options);
            case 2:
              localVarAxiosArgs = _context34.sent;
              return _context34.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }));
    },
    /**
     *
     * @summary Creates an embedding vector representing the input text.
     * @param {CreateEmbeddingRequest} createEmbeddingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmbedding: function createEmbedding(createEmbeddingRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return localVarAxiosParamCreator.createEmbedding(createEmbeddingRequest, options);
            case 2:
              localVarAxiosArgs = _context35.sent;
              return _context35.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }));
    },
    /**
     *
     * @summary Upload a file that contains document(s) to be used across various endpoints/features. Currently, the size of all the files uploaded by one organization can be up to 1 GB. Please contact us if you need to increase the storage limit.
     * @param {File} file Name of the [JSON Lines](https://jsonlines.readthedocs.io/en/latest/) file to be uploaded.  If the &#x60;purpose&#x60; is set to \\\&quot;fine-tune\\\&quot;, each line is a JSON record with \\\&quot;prompt\\\&quot; and \\\&quot;completion\\\&quot; fields representing your [training examples](/docs/guides/fine-tuning/prepare-training-data).
     * @param {string} purpose The intended purpose of the uploaded documents.  Use \\\&quot;fine-tune\\\&quot; for [Fine-tuning](/docs/api-reference/fine-tunes). This allows us to validate the format of the uploaded file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFile: function createFile(file, purpose, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return localVarAxiosParamCreator.createFile(file, purpose, options);
            case 2:
              localVarAxiosArgs = _context36.sent;
              return _context36.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
    },
    /**
     *
     * @summary Creates a job that fine-tunes a specified model from a given dataset.  Response includes details of the enqueued job including job status and the name of the fine-tuned models once complete.  [Learn more about Fine-tuning](/docs/guides/fine-tuning)
     * @param {CreateFineTuneRequest} createFineTuneRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFineTune: function createFineTune(createFineTuneRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return localVarAxiosParamCreator.createFineTune(createFineTuneRequest, options);
            case 2:
              localVarAxiosArgs = _context37.sent;
              return _context37.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }));
    },
    /**
     *
     * @summary Creates an image given a prompt.
     * @param {CreateImageRequest} createImageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createImage: function createImage(createImageRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              _context38.next = 2;
              return localVarAxiosParamCreator.createImage(createImageRequest, options);
            case 2:
              localVarAxiosArgs = _context38.sent;
              return _context38.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context38.stop();
          }
        }, _callee38);
      }));
    },
    /**
     *
     * @summary Creates an edited or extended image given an original image and a prompt.
     * @param {File} image The image to edit. Must be a valid PNG file, less than 4MB, and square. If mask is not provided, image must have transparency, which will be used as the mask.
     * @param {string} prompt A text description of the desired image(s). The maximum length is 1000 characters.
     * @param {File} [mask] An additional image whose fully transparent areas (e.g. where alpha is zero) indicate where &#x60;image&#x60; should be edited. Must be a valid PNG file, less than 4MB, and have the same dimensions as &#x60;image&#x60;.
     * @param {number} [n] The number of images to generate. Must be between 1 and 10.
     * @param {string} [size] The size of the generated images. Must be one of &#x60;256x256&#x60;, &#x60;512x512&#x60;, or &#x60;1024x1024&#x60;.
     * @param {string} [responseFormat] The format in which the generated images are returned. Must be one of &#x60;url&#x60; or &#x60;b64_json&#x60;.
     * @param {string} [user] A unique identifier representing your end-user, which can help OpenAI to monitor and detect abuse. [Learn more](/docs/guides/safety-best-practices/end-user-ids).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createImageEdit: function createImageEdit(image, prompt, mask, n, size, responseFormat, user, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return localVarAxiosParamCreator.createImageEdit(image, prompt, mask, n, size, responseFormat, user, options);
            case 2:
              localVarAxiosArgs = _context39.sent;
              return _context39.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }));
    },
    /**
     *
     * @summary Creates a variation of a given image.
     * @param {File} image The image to use as the basis for the variation(s). Must be a valid PNG file, less than 4MB, and square.
     * @param {number} [n] The number of images to generate. Must be between 1 and 10.
     * @param {string} [size] The size of the generated images. Must be one of &#x60;256x256&#x60;, &#x60;512x512&#x60;, or &#x60;1024x1024&#x60;.
     * @param {string} [responseFormat] The format in which the generated images are returned. Must be one of &#x60;url&#x60; or &#x60;b64_json&#x60;.
     * @param {string} [user] A unique identifier representing your end-user, which can help OpenAI to monitor and detect abuse. [Learn more](/docs/guides/safety-best-practices/end-user-ids).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createImageVariation: function createImageVariation(image, n, size, responseFormat, user, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return localVarAxiosParamCreator.createImageVariation(image, n, size, responseFormat, user, options);
            case 2:
              localVarAxiosArgs = _context40.sent;
              return _context40.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      }));
    },
    /**
     *
     * @summary Classifies if text violates OpenAI\'s Content Policy
     * @param {CreateModerationRequest} createModerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createModeration: function createModeration(createModerationRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return localVarAxiosParamCreator.createModeration(createModerationRequest, options);
            case 2:
              localVarAxiosArgs = _context41.sent;
              return _context41.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }));
    },
    /**
     *
     * @summary The search endpoint computes similarity scores between provided query and documents. Documents can be passed directly to the API if there are no more than 200 of them.  To go beyond the 200 document limit, documents can be processed offline and then used for efficient retrieval at query time. When `file` is set, the search endpoint searches over all the documents in the given file and returns up to the `max_rerank` number of documents. These documents will be returned along with their search scores.  The similarity score is a positive score that usually ranges from 0 to 300 (but can sometimes go higher), where a score above 200 usually means the document is semantically similar to the query.
     * @param {string} engineId The ID of the engine to use for this request.  You can select one of &#x60;ada&#x60;, &#x60;babbage&#x60;, &#x60;curie&#x60;, or &#x60;davinci&#x60;.
     * @param {CreateSearchRequest} createSearchRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createSearch: function createSearch(engineId, createSearchRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return localVarAxiosParamCreator.createSearch(engineId, createSearchRequest, options);
            case 2:
              localVarAxiosArgs = _context42.sent;
              return _context42.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      }));
    },
    /**
     *
     * @summary Transcribes audio into the input language.
     * @param {File} file The audio file to transcribe, in one of these formats: mp3, mp4, mpeg, mpga, m4a, wav, or webm.
     * @param {string} model ID of the model to use. Only &#x60;whisper-1&#x60; is currently available.
     * @param {string} [prompt] An optional text to guide the model\\\&#39;s style or continue a previous audio segment. The [prompt](/docs/guides/speech-to-text/prompting) should match the audio language.
     * @param {string} [responseFormat] The format of the transcript output, in one of these options: json, text, srt, verbose_json, or vtt.
     * @param {number} [temperature] The sampling temperature, between 0 and 1. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic. If set to 0, the model will use [log probability](https://en.wikipedia.org/wiki/Log_probability) to automatically increase the temperature until certain thresholds are hit.
     * @param {string} [language] The language of the input audio. Supplying the input language in [ISO-639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format will improve accuracy and latency.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTranscription: function createTranscription(file, model, prompt, responseFormat, temperature, language, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return localVarAxiosParamCreator.createTranscription(file, model, prompt, responseFormat, temperature, language, options);
            case 2:
              localVarAxiosArgs = _context43.sent;
              return _context43.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context43.stop();
          }
        }, _callee43);
      }));
    },
    /**
     *
     * @summary Translates audio into into English.
     * @param {File} file The audio file to translate, in one of these formats: mp3, mp4, mpeg, mpga, m4a, wav, or webm.
     * @param {string} model ID of the model to use. Only &#x60;whisper-1&#x60; is currently available.
     * @param {string} [prompt] An optional text to guide the model\\\&#39;s style or continue a previous audio segment. The [prompt](/docs/guides/speech-to-text/prompting) should be in English.
     * @param {string} [responseFormat] The format of the transcript output, in one of these options: json, text, srt, verbose_json, or vtt.
     * @param {number} [temperature] The sampling temperature, between 0 and 1. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic. If set to 0, the model will use [log probability](https://en.wikipedia.org/wiki/Log_probability) to automatically increase the temperature until certain thresholds are hit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTranslation: function createTranslation(file, model, prompt, responseFormat, temperature, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              _context44.next = 2;
              return localVarAxiosParamCreator.createTranslation(file, model, prompt, responseFormat, temperature, options);
            case 2:
              localVarAxiosArgs = _context44.sent;
              return _context44.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context44.stop();
          }
        }, _callee44);
      }));
    },
    /**
     *
     * @summary Delete a file.
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile: function deleteFile(fileId, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return localVarAxiosParamCreator.deleteFile(fileId, options);
            case 2:
              localVarAxiosArgs = _context45.sent;
              return _context45.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      }));
    },
    /**
     *
     * @summary Delete a fine-tuned model. You must have the Owner role in your organization.
     * @param {string} model The model to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteModel: function deleteModel(model, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return localVarAxiosParamCreator.deleteModel(model, options);
            case 2:
              localVarAxiosArgs = _context46.sent;
              return _context46.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context46.stop();
          }
        }, _callee46);
      }));
    },
    /**
     *
     * @summary Returns the contents of the specified file
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadFile: function downloadFile(fileId, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              _context47.next = 2;
              return localVarAxiosParamCreator.downloadFile(fileId, options);
            case 2:
              localVarAxiosArgs = _context47.sent;
              return _context47.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context47.stop();
          }
        }, _callee47);
      }));
    },
    /**
     *
     * @summary Lists the currently available (non-finetuned) models, and provides basic information about each one such as the owner and availability.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    listEngines: function listEngines(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              _context48.next = 2;
              return localVarAxiosParamCreator.listEngines(options);
            case 2:
              localVarAxiosArgs = _context48.sent;
              return _context48.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context48.stop();
          }
        }, _callee48);
      }));
    },
    /**
     *
     * @summary Returns a list of files that belong to the user\'s organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listFiles: function listFiles(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              _context49.next = 2;
              return localVarAxiosParamCreator.listFiles(options);
            case 2:
              localVarAxiosArgs = _context49.sent;
              return _context49.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context49.stop();
          }
        }, _callee49);
      }));
    },
    /**
     *
     * @summary Get fine-grained status updates for a fine-tune job.
     * @param {string} fineTuneId The ID of the fine-tune job to get events for.
     * @param {boolean} [stream] Whether to stream events for the fine-tune job. If set to true, events will be sent as data-only [server-sent events](https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events/Using_server-sent_events#Event_stream_format) as they become available. The stream will terminate with a &#x60;data: [DONE]&#x60; message when the job is finished (succeeded, cancelled, or failed).  If set to false, only events generated so far will be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listFineTuneEvents: function listFineTuneEvents(fineTuneId, stream, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              _context50.next = 2;
              return localVarAxiosParamCreator.listFineTuneEvents(fineTuneId, stream, options);
            case 2:
              localVarAxiosArgs = _context50.sent;
              return _context50.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context50.stop();
          }
        }, _callee50);
      }));
    },
    /**
     *
     * @summary List your organization\'s fine-tuning jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listFineTunes: function listFineTunes(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              _context51.next = 2;
              return localVarAxiosParamCreator.listFineTunes(options);
            case 2:
              localVarAxiosArgs = _context51.sent;
              return _context51.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context51.stop();
          }
        }, _callee51);
      }));
    },
    /**
     *
     * @summary Lists the currently available models, and provides basic information about each one such as the owner and availability.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listModels: function listModels(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              _context52.next = 2;
              return localVarAxiosParamCreator.listModels(options);
            case 2:
              localVarAxiosArgs = _context52.sent;
              return _context52.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context52.stop();
          }
        }, _callee52);
      }));
    },
    /**
     *
     * @summary Retrieves a model instance, providing basic information about it such as the owner and availability.
     * @param {string} engineId The ID of the engine to use for this request
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    retrieveEngine: function retrieveEngine(engineId, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              _context53.next = 2;
              return localVarAxiosParamCreator.retrieveEngine(engineId, options);
            case 2:
              localVarAxiosArgs = _context53.sent;
              return _context53.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context53.stop();
          }
        }, _callee53);
      }));
    },
    /**
     *
     * @summary Returns information about a specific file.
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveFile: function retrieveFile(fileId, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              _context54.next = 2;
              return localVarAxiosParamCreator.retrieveFile(fileId, options);
            case 2:
              localVarAxiosArgs = _context54.sent;
              return _context54.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context54.stop();
          }
        }, _callee54);
      }));
    },
    /**
     *
     * @summary Gets info about the fine-tune job.  [Learn more about Fine-tuning](/docs/guides/fine-tuning)
     * @param {string} fineTuneId The ID of the fine-tune job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveFineTune: function retrieveFineTune(fineTuneId, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              _context55.next = 2;
              return localVarAxiosParamCreator.retrieveFineTune(fineTuneId, options);
            case 2:
              localVarAxiosArgs = _context55.sent;
              return _context55.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context55.stop();
          }
        }, _callee55);
      }));
    },
    /**
     *
     * @summary Retrieves a model instance, providing basic information about the model such as the owner and permissioning.
     * @param {string} model The ID of the model to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveModel: function retrieveModel(model, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
        var localVarAxiosArgs;
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              _context56.next = 2;
              return localVarAxiosParamCreator.retrieveModel(model, options);
            case 2:
              localVarAxiosArgs = _context56.sent;
              return _context56.abrupt("return", common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration));
            case 4:
            case "end":
              return _context56.stop();
          }
        }, _callee56);
      }));
    }
  };
};
/**
 * OpenAIApi - factory interface
 * @export
 */
exports.OpenAIApiFactory = function (configuration, basePath, axios) {
  var localVarFp = exports.OpenAIApiFp(configuration);
  return {
    /**
     *
     * @summary Immediately cancel a fine-tune job.
     * @param {string} fineTuneId The ID of the fine-tune job to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelFineTune: function cancelFineTune(fineTuneId, options) {
      return localVarFp.cancelFineTune(fineTuneId, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Answers the specified question using the provided documents and examples.  The endpoint first [searches](/docs/api-reference/searches) over provided documents or files to find relevant context. The relevant context is combined with the provided examples and question to create the prompt for [completion](/docs/api-reference/completions).
     * @param {CreateAnswerRequest} createAnswerRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createAnswer: function createAnswer(createAnswerRequest, options) {
      return localVarFp.createAnswer(createAnswerRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Creates a completion for the chat message
     * @param {CreateChatCompletionRequest} createChatCompletionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createChatCompletion: function createChatCompletion(createChatCompletionRequest, options) {
      return localVarFp.createChatCompletion(createChatCompletionRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Classifies the specified `query` using provided examples.  The endpoint first [searches](/docs/api-reference/searches) over the labeled examples to select the ones most relevant for the particular query. Then, the relevant examples are combined with the query to construct a prompt to produce the final label via the [completions](/docs/api-reference/completions) endpoint.  Labeled examples can be provided via an uploaded `file`, or explicitly listed in the request using the `examples` parameter for quick tests and small scale use cases.
     * @param {CreateClassificationRequest} createClassificationRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createClassification: function createClassification(createClassificationRequest, options) {
      return localVarFp.createClassification(createClassificationRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Creates a completion for the provided prompt and parameters
     * @param {CreateCompletionRequest} createCompletionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompletion: function createCompletion(createCompletionRequest, options) {
      return localVarFp.createCompletion(createCompletionRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Creates a new edit for the provided input, instruction, and parameters.
     * @param {CreateEditRequest} createEditRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEdit: function createEdit(createEditRequest, options) {
      return localVarFp.createEdit(createEditRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Creates an embedding vector representing the input text.
     * @param {CreateEmbeddingRequest} createEmbeddingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmbedding: function createEmbedding(createEmbeddingRequest, options) {
      return localVarFp.createEmbedding(createEmbeddingRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Upload a file that contains document(s) to be used across various endpoints/features. Currently, the size of all the files uploaded by one organization can be up to 1 GB. Please contact us if you need to increase the storage limit.
     * @param {File} file Name of the [JSON Lines](https://jsonlines.readthedocs.io/en/latest/) file to be uploaded.  If the &#x60;purpose&#x60; is set to \\\&quot;fine-tune\\\&quot;, each line is a JSON record with \\\&quot;prompt\\\&quot; and \\\&quot;completion\\\&quot; fields representing your [training examples](/docs/guides/fine-tuning/prepare-training-data).
     * @param {string} purpose The intended purpose of the uploaded documents.  Use \\\&quot;fine-tune\\\&quot; for [Fine-tuning](/docs/api-reference/fine-tunes). This allows us to validate the format of the uploaded file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFile: function createFile(file, purpose, options) {
      return localVarFp.createFile(file, purpose, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Creates a job that fine-tunes a specified model from a given dataset.  Response includes details of the enqueued job including job status and the name of the fine-tuned models once complete.  [Learn more about Fine-tuning](/docs/guides/fine-tuning)
     * @param {CreateFineTuneRequest} createFineTuneRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFineTune: function createFineTune(createFineTuneRequest, options) {
      return localVarFp.createFineTune(createFineTuneRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Creates an image given a prompt.
     * @param {CreateImageRequest} createImageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createImage: function createImage(createImageRequest, options) {
      return localVarFp.createImage(createImageRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Creates an edited or extended image given an original image and a prompt.
     * @param {File} image The image to edit. Must be a valid PNG file, less than 4MB, and square. If mask is not provided, image must have transparency, which will be used as the mask.
     * @param {string} prompt A text description of the desired image(s). The maximum length is 1000 characters.
     * @param {File} [mask] An additional image whose fully transparent areas (e.g. where alpha is zero) indicate where &#x60;image&#x60; should be edited. Must be a valid PNG file, less than 4MB, and have the same dimensions as &#x60;image&#x60;.
     * @param {number} [n] The number of images to generate. Must be between 1 and 10.
     * @param {string} [size] The size of the generated images. Must be one of &#x60;256x256&#x60;, &#x60;512x512&#x60;, or &#x60;1024x1024&#x60;.
     * @param {string} [responseFormat] The format in which the generated images are returned. Must be one of &#x60;url&#x60; or &#x60;b64_json&#x60;.
     * @param {string} [user] A unique identifier representing your end-user, which can help OpenAI to monitor and detect abuse. [Learn more](/docs/guides/safety-best-practices/end-user-ids).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createImageEdit: function createImageEdit(image, prompt, mask, n, size, responseFormat, user, options) {
      return localVarFp.createImageEdit(image, prompt, mask, n, size, responseFormat, user, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Creates a variation of a given image.
     * @param {File} image The image to use as the basis for the variation(s). Must be a valid PNG file, less than 4MB, and square.
     * @param {number} [n] The number of images to generate. Must be between 1 and 10.
     * @param {string} [size] The size of the generated images. Must be one of &#x60;256x256&#x60;, &#x60;512x512&#x60;, or &#x60;1024x1024&#x60;.
     * @param {string} [responseFormat] The format in which the generated images are returned. Must be one of &#x60;url&#x60; or &#x60;b64_json&#x60;.
     * @param {string} [user] A unique identifier representing your end-user, which can help OpenAI to monitor and detect abuse. [Learn more](/docs/guides/safety-best-practices/end-user-ids).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createImageVariation: function createImageVariation(image, n, size, responseFormat, user, options) {
      return localVarFp.createImageVariation(image, n, size, responseFormat, user, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Classifies if text violates OpenAI\'s Content Policy
     * @param {CreateModerationRequest} createModerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createModeration: function createModeration(createModerationRequest, options) {
      return localVarFp.createModeration(createModerationRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary The search endpoint computes similarity scores between provided query and documents. Documents can be passed directly to the API if there are no more than 200 of them.  To go beyond the 200 document limit, documents can be processed offline and then used for efficient retrieval at query time. When `file` is set, the search endpoint searches over all the documents in the given file and returns up to the `max_rerank` number of documents. These documents will be returned along with their search scores.  The similarity score is a positive score that usually ranges from 0 to 300 (but can sometimes go higher), where a score above 200 usually means the document is semantically similar to the query.
     * @param {string} engineId The ID of the engine to use for this request.  You can select one of &#x60;ada&#x60;, &#x60;babbage&#x60;, &#x60;curie&#x60;, or &#x60;davinci&#x60;.
     * @param {CreateSearchRequest} createSearchRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createSearch: function createSearch(engineId, createSearchRequest, options) {
      return localVarFp.createSearch(engineId, createSearchRequest, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Transcribes audio into the input language.
     * @param {File} file The audio file to transcribe, in one of these formats: mp3, mp4, mpeg, mpga, m4a, wav, or webm.
     * @param {string} model ID of the model to use. Only &#x60;whisper-1&#x60; is currently available.
     * @param {string} [prompt] An optional text to guide the model\\\&#39;s style or continue a previous audio segment. The [prompt](/docs/guides/speech-to-text/prompting) should match the audio language.
     * @param {string} [responseFormat] The format of the transcript output, in one of these options: json, text, srt, verbose_json, or vtt.
     * @param {number} [temperature] The sampling temperature, between 0 and 1. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic. If set to 0, the model will use [log probability](https://en.wikipedia.org/wiki/Log_probability) to automatically increase the temperature until certain thresholds are hit.
     * @param {string} [language] The language of the input audio. Supplying the input language in [ISO-639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format will improve accuracy and latency.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTranscription: function createTranscription(file, model, prompt, responseFormat, temperature, language, options) {
      return localVarFp.createTranscription(file, model, prompt, responseFormat, temperature, language, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Translates audio into into English.
     * @param {File} file The audio file to translate, in one of these formats: mp3, mp4, mpeg, mpga, m4a, wav, or webm.
     * @param {string} model ID of the model to use. Only &#x60;whisper-1&#x60; is currently available.
     * @param {string} [prompt] An optional text to guide the model\\\&#39;s style or continue a previous audio segment. The [prompt](/docs/guides/speech-to-text/prompting) should be in English.
     * @param {string} [responseFormat] The format of the transcript output, in one of these options: json, text, srt, verbose_json, or vtt.
     * @param {number} [temperature] The sampling temperature, between 0 and 1. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic. If set to 0, the model will use [log probability](https://en.wikipedia.org/wiki/Log_probability) to automatically increase the temperature until certain thresholds are hit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTranslation: function createTranslation(file, model, prompt, responseFormat, temperature, options) {
      return localVarFp.createTranslation(file, model, prompt, responseFormat, temperature, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Delete a file.
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile: function deleteFile(fileId, options) {
      return localVarFp.deleteFile(fileId, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Delete a fine-tuned model. You must have the Owner role in your organization.
     * @param {string} model The model to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteModel: function deleteModel(model, options) {
      return localVarFp.deleteModel(model, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Returns the contents of the specified file
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadFile: function downloadFile(fileId, options) {
      return localVarFp.downloadFile(fileId, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Lists the currently available (non-finetuned) models, and provides basic information about each one such as the owner and availability.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    listEngines: function listEngines(options) {
      return localVarFp.listEngines(options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Returns a list of files that belong to the user\'s organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listFiles: function listFiles(options) {
      return localVarFp.listFiles(options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Get fine-grained status updates for a fine-tune job.
     * @param {string} fineTuneId The ID of the fine-tune job to get events for.
     * @param {boolean} [stream] Whether to stream events for the fine-tune job. If set to true, events will be sent as data-only [server-sent events](https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events/Using_server-sent_events#Event_stream_format) as they become available. The stream will terminate with a &#x60;data: [DONE]&#x60; message when the job is finished (succeeded, cancelled, or failed).  If set to false, only events generated so far will be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listFineTuneEvents: function listFineTuneEvents(fineTuneId, stream, options) {
      return localVarFp.listFineTuneEvents(fineTuneId, stream, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary List your organization\'s fine-tuning jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listFineTunes: function listFineTunes(options) {
      return localVarFp.listFineTunes(options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Lists the currently available models, and provides basic information about each one such as the owner and availability.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listModels: function listModels(options) {
      return localVarFp.listModels(options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Retrieves a model instance, providing basic information about it such as the owner and availability.
     * @param {string} engineId The ID of the engine to use for this request
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    retrieveEngine: function retrieveEngine(engineId, options) {
      return localVarFp.retrieveEngine(engineId, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Returns information about a specific file.
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveFile: function retrieveFile(fileId, options) {
      return localVarFp.retrieveFile(fileId, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Gets info about the fine-tune job.  [Learn more about Fine-tuning](/docs/guides/fine-tuning)
     * @param {string} fineTuneId The ID of the fine-tune job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveFineTune: function retrieveFineTune(fineTuneId, options) {
      return localVarFp.retrieveFineTune(fineTuneId, options).then(function (request) {
        return request(axios, basePath);
      });
    },
    /**
     *
     * @summary Retrieves a model instance, providing basic information about the model such as the owner and permissioning.
     * @param {string} model The ID of the model to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveModel: function retrieveModel(model, options) {
      return localVarFp.retrieveModel(model, options).then(function (request) {
        return request(axios, basePath);
      });
    }
  };
};
/**
 * OpenAIApi - object-oriented interface
 * @export
 * @class OpenAIApi
 * @extends {BaseAPI}
 */
var OpenAIApi = /*#__PURE__*/function (_base_1$BaseAPI) {
  _inherits(OpenAIApi, _base_1$BaseAPI);
  function OpenAIApi() {
    _classCallCheck(this, OpenAIApi);
    return _possibleConstructorReturn(this, _getPrototypeOf(OpenAIApi).apply(this, arguments));
  }
  _createClass(OpenAIApi, [{
    key: "cancelFineTune",
    /**
     *
     * @summary Immediately cancel a fine-tune job.
     * @param {string} fineTuneId The ID of the fine-tune job to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    value: function cancelFineTune(fineTuneId, options) {
      var _this2 = this;
      return exports.OpenAIApiFp(this.configuration).cancelFineTune(fineTuneId, options).then(function (request) {
        return request(_this2.axios, _this2.basePath);
      });
    }
    /**
     *
     * @summary Answers the specified question using the provided documents and examples.  The endpoint first [searches](/docs/api-reference/searches) over provided documents or files to find relevant context. The relevant context is combined with the provided examples and question to create the prompt for [completion](/docs/api-reference/completions).
     * @param {CreateAnswerRequest} createAnswerRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createAnswer",
    value: function createAnswer(createAnswerRequest, options) {
      var _this3 = this;
      return exports.OpenAIApiFp(this.configuration).createAnswer(createAnswerRequest, options).then(function (request) {
        return request(_this3.axios, _this3.basePath);
      });
    }
    /**
     *
     * @summary Creates a completion for the chat message
     * @param {CreateChatCompletionRequest} createChatCompletionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createChatCompletion",
    value: function createChatCompletion(createChatCompletionRequest, options) {
      var _this4 = this;
      return exports.OpenAIApiFp(this.configuration).createChatCompletion(createChatCompletionRequest, options).then(function (request) {
        return request(_this4.axios, _this4.basePath);
      });
    }
    /**
     *
     * @summary Classifies the specified `query` using provided examples.  The endpoint first [searches](/docs/api-reference/searches) over the labeled examples to select the ones most relevant for the particular query. Then, the relevant examples are combined with the query to construct a prompt to produce the final label via the [completions](/docs/api-reference/completions) endpoint.  Labeled examples can be provided via an uploaded `file`, or explicitly listed in the request using the `examples` parameter for quick tests and small scale use cases.
     * @param {CreateClassificationRequest} createClassificationRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createClassification",
    value: function createClassification(createClassificationRequest, options) {
      var _this5 = this;
      return exports.OpenAIApiFp(this.configuration).createClassification(createClassificationRequest, options).then(function (request) {
        return request(_this5.axios, _this5.basePath);
      });
    }
    /**
     *
     * @summary Creates a completion for the provided prompt and parameters
     * @param {CreateCompletionRequest} createCompletionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createCompletion",
    value: function createCompletion(createCompletionRequest, options) {
      var _this6 = this;
      return exports.OpenAIApiFp(this.configuration).createCompletion(createCompletionRequest, options).then(function (request) {
        return request(_this6.axios, _this6.basePath);
      });
    }
    /**
     *
     * @summary Creates a new edit for the provided input, instruction, and parameters.
     * @param {CreateEditRequest} createEditRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createEdit",
    value: function createEdit(createEditRequest, options) {
      var _this7 = this;
      return exports.OpenAIApiFp(this.configuration).createEdit(createEditRequest, options).then(function (request) {
        return request(_this7.axios, _this7.basePath);
      });
    }
    /**
     *
     * @summary Creates an embedding vector representing the input text.
     * @param {CreateEmbeddingRequest} createEmbeddingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createEmbedding",
    value: function createEmbedding(createEmbeddingRequest, options) {
      var _this8 = this;
      return exports.OpenAIApiFp(this.configuration).createEmbedding(createEmbeddingRequest, options).then(function (request) {
        return request(_this8.axios, _this8.basePath);
      });
    }
    /**
     *
     * @summary Upload a file that contains document(s) to be used across various endpoints/features. Currently, the size of all the files uploaded by one organization can be up to 1 GB. Please contact us if you need to increase the storage limit.
     * @param {File} file Name of the [JSON Lines](https://jsonlines.readthedocs.io/en/latest/) file to be uploaded.  If the &#x60;purpose&#x60; is set to \\\&quot;fine-tune\\\&quot;, each line is a JSON record with \\\&quot;prompt\\\&quot; and \\\&quot;completion\\\&quot; fields representing your [training examples](/docs/guides/fine-tuning/prepare-training-data).
     * @param {string} purpose The intended purpose of the uploaded documents.  Use \\\&quot;fine-tune\\\&quot; for [Fine-tuning](/docs/api-reference/fine-tunes). This allows us to validate the format of the uploaded file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createFile",
    value: function createFile(file, purpose, options) {
      var _this9 = this;
      return exports.OpenAIApiFp(this.configuration).createFile(file, purpose, options).then(function (request) {
        return request(_this9.axios, _this9.basePath);
      });
    }
    /**
     *
     * @summary Creates a job that fine-tunes a specified model from a given dataset.  Response includes details of the enqueued job including job status and the name of the fine-tuned models once complete.  [Learn more about Fine-tuning](/docs/guides/fine-tuning)
     * @param {CreateFineTuneRequest} createFineTuneRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createFineTune",
    value: function createFineTune(createFineTuneRequest, options) {
      var _this10 = this;
      return exports.OpenAIApiFp(this.configuration).createFineTune(createFineTuneRequest, options).then(function (request) {
        return request(_this10.axios, _this10.basePath);
      });
    }
    /**
     *
     * @summary Creates an image given a prompt.
     * @param {CreateImageRequest} createImageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createImage",
    value: function createImage(createImageRequest, options) {
      var _this11 = this;
      return exports.OpenAIApiFp(this.configuration).createImage(createImageRequest, options).then(function (request) {
        return request(_this11.axios, _this11.basePath);
      });
    }
    /**
     *
     * @summary Creates an edited or extended image given an original image and a prompt.
     * @param {File} image The image to edit. Must be a valid PNG file, less than 4MB, and square. If mask is not provided, image must have transparency, which will be used as the mask.
     * @param {string} prompt A text description of the desired image(s). The maximum length is 1000 characters.
     * @param {File} [mask] An additional image whose fully transparent areas (e.g. where alpha is zero) indicate where &#x60;image&#x60; should be edited. Must be a valid PNG file, less than 4MB, and have the same dimensions as &#x60;image&#x60;.
     * @param {number} [n] The number of images to generate. Must be between 1 and 10.
     * @param {string} [size] The size of the generated images. Must be one of &#x60;256x256&#x60;, &#x60;512x512&#x60;, or &#x60;1024x1024&#x60;.
     * @param {string} [responseFormat] The format in which the generated images are returned. Must be one of &#x60;url&#x60; or &#x60;b64_json&#x60;.
     * @param {string} [user] A unique identifier representing your end-user, which can help OpenAI to monitor and detect abuse. [Learn more](/docs/guides/safety-best-practices/end-user-ids).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createImageEdit",
    value: function createImageEdit(image, prompt, mask, n, size, responseFormat, user, options) {
      var _this12 = this;
      return exports.OpenAIApiFp(this.configuration).createImageEdit(image, prompt, mask, n, size, responseFormat, user, options).then(function (request) {
        return request(_this12.axios, _this12.basePath);
      });
    }
    /**
     *
     * @summary Creates a variation of a given image.
     * @param {File} image The image to use as the basis for the variation(s). Must be a valid PNG file, less than 4MB, and square.
     * @param {number} [n] The number of images to generate. Must be between 1 and 10.
     * @param {string} [size] The size of the generated images. Must be one of &#x60;256x256&#x60;, &#x60;512x512&#x60;, or &#x60;1024x1024&#x60;.
     * @param {string} [responseFormat] The format in which the generated images are returned. Must be one of &#x60;url&#x60; or &#x60;b64_json&#x60;.
     * @param {string} [user] A unique identifier representing your end-user, which can help OpenAI to monitor and detect abuse. [Learn more](/docs/guides/safety-best-practices/end-user-ids).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createImageVariation",
    value: function createImageVariation(image, n, size, responseFormat, user, options) {
      var _this13 = this;
      return exports.OpenAIApiFp(this.configuration).createImageVariation(image, n, size, responseFormat, user, options).then(function (request) {
        return request(_this13.axios, _this13.basePath);
      });
    }
    /**
     *
     * @summary Classifies if text violates OpenAI\'s Content Policy
     * @param {CreateModerationRequest} createModerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createModeration",
    value: function createModeration(createModerationRequest, options) {
      var _this14 = this;
      return exports.OpenAIApiFp(this.configuration).createModeration(createModerationRequest, options).then(function (request) {
        return request(_this14.axios, _this14.basePath);
      });
    }
    /**
     *
     * @summary The search endpoint computes similarity scores between provided query and documents. Documents can be passed directly to the API if there are no more than 200 of them.  To go beyond the 200 document limit, documents can be processed offline and then used for efficient retrieval at query time. When `file` is set, the search endpoint searches over all the documents in the given file and returns up to the `max_rerank` number of documents. These documents will be returned along with their search scores.  The similarity score is a positive score that usually ranges from 0 to 300 (but can sometimes go higher), where a score above 200 usually means the document is semantically similar to the query.
     * @param {string} engineId The ID of the engine to use for this request.  You can select one of &#x60;ada&#x60;, &#x60;babbage&#x60;, &#x60;curie&#x60;, or &#x60;davinci&#x60;.
     * @param {CreateSearchRequest} createSearchRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createSearch",
    value: function createSearch(engineId, createSearchRequest, options) {
      var _this15 = this;
      return exports.OpenAIApiFp(this.configuration).createSearch(engineId, createSearchRequest, options).then(function (request) {
        return request(_this15.axios, _this15.basePath);
      });
    }
    /**
     *
     * @summary Transcribes audio into the input language.
     * @param {File} file The audio file to transcribe, in one of these formats: mp3, mp4, mpeg, mpga, m4a, wav, or webm.
     * @param {string} model ID of the model to use. Only &#x60;whisper-1&#x60; is currently available.
     * @param {string} [prompt] An optional text to guide the model\\\&#39;s style or continue a previous audio segment. The [prompt](/docs/guides/speech-to-text/prompting) should match the audio language.
     * @param {string} [responseFormat] The format of the transcript output, in one of these options: json, text, srt, verbose_json, or vtt.
     * @param {number} [temperature] The sampling temperature, between 0 and 1. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic. If set to 0, the model will use [log probability](https://en.wikipedia.org/wiki/Log_probability) to automatically increase the temperature until certain thresholds are hit.
     * @param {string} [language] The language of the input audio. Supplying the input language in [ISO-639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format will improve accuracy and latency.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createTranscription",
    value: function createTranscription(file, model, prompt, responseFormat, temperature, language, options) {
      var _this16 = this;
      return exports.OpenAIApiFp(this.configuration).createTranscription(file, model, prompt, responseFormat, temperature, language, options).then(function (request) {
        return request(_this16.axios, _this16.basePath);
      });
    }
    /**
     *
     * @summary Translates audio into into English.
     * @param {File} file The audio file to translate, in one of these formats: mp3, mp4, mpeg, mpga, m4a, wav, or webm.
     * @param {string} model ID of the model to use. Only &#x60;whisper-1&#x60; is currently available.
     * @param {string} [prompt] An optional text to guide the model\\\&#39;s style or continue a previous audio segment. The [prompt](/docs/guides/speech-to-text/prompting) should be in English.
     * @param {string} [responseFormat] The format of the transcript output, in one of these options: json, text, srt, verbose_json, or vtt.
     * @param {number} [temperature] The sampling temperature, between 0 and 1. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic. If set to 0, the model will use [log probability](https://en.wikipedia.org/wiki/Log_probability) to automatically increase the temperature until certain thresholds are hit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "createTranslation",
    value: function createTranslation(file, model, prompt, responseFormat, temperature, options) {
      var _this17 = this;
      return exports.OpenAIApiFp(this.configuration).createTranslation(file, model, prompt, responseFormat, temperature, options).then(function (request) {
        return request(_this17.axios, _this17.basePath);
      });
    }
    /**
     *
     * @summary Delete a file.
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "deleteFile",
    value: function deleteFile(fileId, options) {
      var _this18 = this;
      return exports.OpenAIApiFp(this.configuration).deleteFile(fileId, options).then(function (request) {
        return request(_this18.axios, _this18.basePath);
      });
    }
    /**
     *
     * @summary Delete a fine-tuned model. You must have the Owner role in your organization.
     * @param {string} model The model to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "deleteModel",
    value: function deleteModel(model, options) {
      var _this19 = this;
      return exports.OpenAIApiFp(this.configuration).deleteModel(model, options).then(function (request) {
        return request(_this19.axios, _this19.basePath);
      });
    }
    /**
     *
     * @summary Returns the contents of the specified file
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "downloadFile",
    value: function downloadFile(fileId, options) {
      var _this20 = this;
      return exports.OpenAIApiFp(this.configuration).downloadFile(fileId, options).then(function (request) {
        return request(_this20.axios, _this20.basePath);
      });
    }
    /**
     *
     * @summary Lists the currently available (non-finetuned) models, and provides basic information about each one such as the owner and availability.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "listEngines",
    value: function listEngines(options) {
      var _this21 = this;
      return exports.OpenAIApiFp(this.configuration).listEngines(options).then(function (request) {
        return request(_this21.axios, _this21.basePath);
      });
    }
    /**
     *
     * @summary Returns a list of files that belong to the user\'s organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "listFiles",
    value: function listFiles(options) {
      var _this22 = this;
      return exports.OpenAIApiFp(this.configuration).listFiles(options).then(function (request) {
        return request(_this22.axios, _this22.basePath);
      });
    }
    /**
     *
     * @summary Get fine-grained status updates for a fine-tune job.
     * @param {string} fineTuneId The ID of the fine-tune job to get events for.
     * @param {boolean} [stream] Whether to stream events for the fine-tune job. If set to true, events will be sent as data-only [server-sent events](https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events/Using_server-sent_events#Event_stream_format) as they become available. The stream will terminate with a &#x60;data: [DONE]&#x60; message when the job is finished (succeeded, cancelled, or failed).  If set to false, only events generated so far will be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "listFineTuneEvents",
    value: function listFineTuneEvents(fineTuneId, stream, options) {
      var _this23 = this;
      return exports.OpenAIApiFp(this.configuration).listFineTuneEvents(fineTuneId, stream, options).then(function (request) {
        return request(_this23.axios, _this23.basePath);
      });
    }
    /**
     *
     * @summary List your organization\'s fine-tuning jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "listFineTunes",
    value: function listFineTunes(options) {
      var _this24 = this;
      return exports.OpenAIApiFp(this.configuration).listFineTunes(options).then(function (request) {
        return request(_this24.axios, _this24.basePath);
      });
    }
    /**
     *
     * @summary Lists the currently available models, and provides basic information about each one such as the owner and availability.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "listModels",
    value: function listModels(options) {
      var _this25 = this;
      return exports.OpenAIApiFp(this.configuration).listModels(options).then(function (request) {
        return request(_this25.axios, _this25.basePath);
      });
    }
    /**
     *
     * @summary Retrieves a model instance, providing basic information about it such as the owner and availability.
     * @param {string} engineId The ID of the engine to use for this request
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "retrieveEngine",
    value: function retrieveEngine(engineId, options) {
      var _this26 = this;
      return exports.OpenAIApiFp(this.configuration).retrieveEngine(engineId, options).then(function (request) {
        return request(_this26.axios, _this26.basePath);
      });
    }
    /**
     *
     * @summary Returns information about a specific file.
     * @param {string} fileId The ID of the file to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "retrieveFile",
    value: function retrieveFile(fileId, options) {
      var _this27 = this;
      return exports.OpenAIApiFp(this.configuration).retrieveFile(fileId, options).then(function (request) {
        return request(_this27.axios, _this27.basePath);
      });
    }
    /**
     *
     * @summary Gets info about the fine-tune job.  [Learn more about Fine-tuning](/docs/guides/fine-tuning)
     * @param {string} fineTuneId The ID of the fine-tune job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "retrieveFineTune",
    value: function retrieveFineTune(fineTuneId, options) {
      var _this28 = this;
      return exports.OpenAIApiFp(this.configuration).retrieveFineTune(fineTuneId, options).then(function (request) {
        return request(_this28.axios, _this28.basePath);
      });
    }
    /**
     *
     * @summary Retrieves a model instance, providing basic information about the model such as the owner and permissioning.
     * @param {string} model The ID of the model to use for this request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
  }, {
    key: "retrieveModel",
    value: function retrieveModel(model, options) {
      var _this29 = this;
      return exports.OpenAIApiFp(this.configuration).retrieveModel(model, options).then(function (request) {
        return request(_this29.axios, _this29.basePath);
      });
    }
  }]);
  return OpenAIApi;
}(base_1.BaseAPI);
exports.OpenAIApi = OpenAIApi;